import React from "react";

// components
import { Card, CardTitle, CardBody, CardFooter, Row, Col, Spinner, Label } from "reactstrap";

// style
import "assets/css/loading.css";

// logos
import logo_spRegula from "assets/img/SPRegula.png";
import logo_saopaulo from "assets/img/saopaulo.png";

// helpers
import { transformFloatToString, transformValueFloattoFormated } from "helpers/formats.js";

import Acoes from "./Acoes";

import { Bar } from 'react-chartjs-2';

export default function PainelGrafico(props) {
  const {
    showLoading,
    painel,
    showPlay,
    toggleModalSetup,
    handleConfirmaSetup,
    handleBackward,
    handlePauseMap,
    handlePlayMap,
    handleForward
  } = props;

  return (
    <>
      <Card className="card-stats">
        {(painel != null) && painel.grupo &&
          <CardBody>
            <Row>
              <Col md="3" xs="3">
                <Acoes
                  showLoading = {showLoading}
                  showPlay = {showPlay}
                  handleBackward = {handleBackward}
                  handlePauseMap = {handlePauseMap}
                  handlePlayMap = {handlePlayMap}
                  handleForward = {handleForward}
                  toggleModalSetup = {toggleModalSetup}
                  handleConfirmaSetup = {handleConfirmaSetup}
                />
                <Row>
                  <Col md="12" xs="12">
                    {painel.titulo &&
                      <h4 className="title" style={{ marginBottom: "0" }}>
                        {painel.titulo}
                      </h4>
                    }
                  </Col>
                </Row>
                {painel.subTitulo != null && painel.subTitulo != "" &&
                  <Row>
                    <Col md="12" xs="12">
                      <h5 style={{ marginBottom: "0" }}>
                          {painel.subTitulo}
                      </h5>
                    </Col>
                  </Row>
                }
                {painel.descricao != null && painel.descricao != "" &&
                  <Row>
                    <Col md="12" xs="12">
                      <small>{painel.descricao}</small>
                    </Col>
                  </Row>
                }
                {(painel != null) && (painel.cards != null) && painel.cards.map((item, key) => (
                  <Card key={key} className="card-stats">
                    <CardBody>
                      <Row>
                        <Col md="4" xs="3">
                          <div className={"icon-big text-center " + item.color}>
                            <i className={item.icon}></i>
                          </div>
                        </Col>
                        <Col md="8" xs="9">
                          <div className="numbers">
                            <p className="card-category">{item.titulo}</p>
                              <CardTitle tag="p">
                                {!showLoading && item.mascara == "milhar" &&
                                  <Label style={{ color: "#2c2c2c" }}>{transformFloatToString(item.total)}</Label>
                                }
                                {!showLoading && item.mascara != "milhar" &&
                                  <Label style={{ color: "#2c2c2c" }}>{transformValueFloattoFormated(item.total)}</Label>
                                }
                                {showLoading &&
                                  <Spinner />
                                }
                              </CardTitle>
                            <p />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    {item.descricao &&
                      <CardFooter>
                        <hr />
                        <div className="stats">
                          {item.descricao}
                        </div>
                      </CardFooter>
                    }
                  </Card>
                ))}
              </Col>
              <Col md="9" xs="9">
                {(painel != null) && (painel.graficos != null) && painel.graficos.map((item, key) => (
                  <Bar key={key} data={item} />
                ))}
                <Row className="mt-1">
                  <Col md="4" xs="4" className="text-left">
                    <img src={logo_spRegula} height={"50px"} />
                  </Col>
                  <Col md="4" xs="4" className="text-right">
                    <img src={logo_saopaulo} height={"50px"} style={{ marginBottom: "10px" }} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        }
      </Card>
    </>
  );
}